export default __webpack_public_path__ + "static/media/G0100-Figure_5.1.1664356080000.5452e318.jpg";